import {  CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import {  RouterOutlet } from '@angular/router';
import { LoaderComponent } from './pages/general/components/loader/loader.component';
import { MultiLanguageModule } from './pages/general/components/multi-language/multi-language/multi-language.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { ActivityService } from './pages/general/services/activity.service';
import { SessionService } from './pages/general/services/session.service';
import { ActivityHitService } from './pages/general/services/activityhit.service';
// import { Encryptor } from 'npm-crypto-encryptor/dist/encryptor';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule,MultiLanguageModule, NgxSpinnerModule,
    RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit,OnDestroy {
  title = 'NGA_NG_NEXTGEN_PORTAL';
  userActivity:any;
  private activitySubscription: Subscription|any;
  userInactive: Subject<any> = new Subject();
  constructor(private keycloakservice:KeycloakService,private activityService: ActivityService,
    private sessionService: SessionService,private readonly activityHit:ActivityHitService){
    // this.setTimeout();
    // this.userInactive.subscribe(() => {
    //   alert("There is no Acitivity for a while. So we close the session.")
    //   this.logout(); 
    // });
  }
  ngOnInit(): void {
    // const js:any = [{"name":"test","arry":[{name:"test1"}]}]
    // const encrydt = Encryptor.encrypt(JSON.stringify(js));
    // console.log(encrydt)
    // const dencrydt = Encryptor.decrypt(encrydt);
    // console.log(JSON.parse(dencrydt))
    // console.log(Encryptor.decrypt("ldVXY2dnbHZYCJ+Rvz/ZMw=="))
    this.activitySubscription = this.activityService.active$.subscribe(isActive => {
      if (isActive) {
        this.sessionService.updateSession();
      }
    });
    setTimeout(() => {
    this.sendloginHit();
    }, 2000);
  }

  sendloginHit(){
    try {
      const localVal:any = this.sessionService.getActivityStore();
      if(localVal == null || localVal == undefined || localVal == ''){
        
          const requBdy:any = {
            "applId": "DEFAULT"
          }
          const result:any = this.activityHit.getMenuexternal(requBdy);
          setTimeout(() => {
           this.sessionService.setActivityStore();            
          }, 1000);
          // console.log("Login Hit Api-",result)
      }

    } catch (error) {
      console.log("Error Login Hit Api-",error)
    }


  }
  ngOnDestroy() {
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
    }
  }
  // @HostListener('window:mousemove') refreshUserState() {
  //   this.resetTimeout();
  // }

  // @HostListener('window:click') onWindowClick() {
  //   this.resetTimeout();
  // }

  // @HostListener('window:keydown') onWindowKeydown() {
  //   this.resetTimeout();
  // }

  // @HostListener('window:scroll') onWindowScroll() {
  //   this.resetTimeout();
  // }

  // resetTimeout() {
  //   clearTimeout(this.userActivity);
  //   this.setTimeout();
  // }

  // setTimeout() {
  //   const timeInMilliseconds = 20 * 60 * 1000; // 10 minutes in milliseconds
  //   this.userActivity = setTimeout(() => this.userInactive.next(undefined), timeInMilliseconds);
  // }


  logout(){
    this.keycloakservice.logout();
}
}
